export const common = {
  nav: {
    service: 'Service',
    ablauf: 'Process',
    process: 'Process',
    buchen: 'Book',
    book: 'Book',
    jetztBuchen: 'Book Now',
    bookNow: 'Book Now',
    menuOpen: 'Open menu',
    subtitle: 'SKI-SERVICE COURIER',
  },

  hero: {
    badge: 'order until {{orderDeadline}} • {{returnTime}} return',
    skiServiceKurier: 'SKI-SERVICE COURIER',
    subtitle: 'SKI-SERVICE COURIER',
    headline1: 'SKI PICK-UP SERVICE',
    headline2: 'OVERNIGHT SERVICE',
    headline3: 'BACK BY {{returnTime}}',
    cardTitle: 'CONVENIENT AND EASY FROM HOME',
    cardSubtitle: 'PERFECTLY PREPARED SKIS',
    cardDescription: 'We pick up your skis in the evening, perform a professional service and bring them back the next morning by {{returnTime}} at the latest, perfectly prepared. So you can start your ski day safely and with perfect grip.',
    ctaButton: 'BOOK NOW',
    availableIn: 'Available in:',
    location1: '7247 Saas',
    location2: '7249 Serneus',
    location3: '7250 Klosters',
    inCollabWith: 'In collaboration with',
  },

  howItWorks: {
    title: 'Four simple steps to perfectly prepared skis',
    titleMobile: 'Four simple steps',
    stepLabel: 'STEP',
    step1: {
      title: 'Order service until {{orderDeadline}}',
      titleMobile: 'Order until {{orderDeadline}}',
      description: 'Order your ski service conveniently online – simply by {{orderDeadline}} at the latest on the desired evening.',
      descriptionMobile: 'Order conveniently online – until {{orderDeadline}}.',
    },
    step2: {
      title: 'Pick-up in the evening at your doorstep',
      titleMobile: 'Pick-up in the evening',
      description: 'In the evening we pick up your skis conveniently directly at your accommodation. Fast, convenient and reliable.',
      descriptionMobile: 'We pick up your skis directly at your accommodation.',
    },
    step3: {
      title: 'Professional service & quality control',
      titleMobile: 'Professional overnight service',
      description: 'Our experts grind, wax and repair your skis with state-of-the-art technology. Each pair then undergoes a final quality check.',
      descriptionMobile: 'Grinding, waxing, repairing – with final quality check.',
    },
    step4: {
      title: 'Return by {{returnTime}}',
      titleMobile: 'Return by {{returnTime}}',
      description: 'We bring your skis back punctually by {{returnTime}}. Perfectly prepared for the first lift.',
      descriptionMobile: 'Back by {{returnTime}} – ready for the first lift.',
    },
  },

  services: {
    sectionLabel: 'OUR SERVICES',
    sectionTitle: 'CHOOSE YOUR SERVICE',
    discount: 'Introductory discount',
    bookButton: 'BOOK',
    mobileBookButton: 'BOOK',
    modalBookButton: 'BOOK NOW',
    modalFeaturesLabel: 'Services',
    juniorLengthNote: 'Only for skis up to 1.5 m in length',
    junior: {
      title: 'JUNIOR SERVICE',
      description: 'Same professional service as the Standard – specially for children\'s skis up to 1.5 m in length.',
      feature1: 'Base grinding',
      feature2: 'Edge sharpening – side',
      feature3: 'Edge sharpening – base bevel',
      feature4: 'Waxing',
      feature5: 'Polishing',
      feature6: 'Only for skis up to 1.5 m in length',
      mobileFeature1: 'Base grinding',
      mobileFeature2: 'Edge sharpening',
      mobileFeature3: 'Waxing & polishing',
    },
    kleiner: {
      title: 'STANDARD SERVICE',
      description: 'Professional edge sharpening, base waxing, and structure grinding restoration.',
      feature1: 'Base grinding',
      feature2: 'Edge sharpening – side',
      feature3: 'Edge sharpening – base bevel',
      feature4: 'Waxing',
      feature5: 'Polishing',
      mobileFeature1: 'Base grinding',
      mobileFeature2: 'Edge sharpening',
      mobileFeature3: 'Base waxing & polishing',
    },
    grosser: {
      title: 'PRO SERVICE',
      description: 'Full service with base repair, grinding, edge sharpening, waxing and polishing for optimal performance.',
      feature1: 'Pour base and fill all large and small gouges',
      feature2: 'Base pre-grinding',
      feature3: 'Base fine-grinding',
      feature4: 'Edge sharpening – side',
      feature5: 'Edge sharpening – base bevel',
      feature6: 'Waxing',
      feature7: 'Polishing',
      mobileFeature1: 'Base repair, fill & grind',
      mobileFeature2: 'Edge sharpening',
      mobileFeature3: 'Base waxing & polishing',
    },
    renn: {
      title: 'RACE SERVICE',
      description: 'Complete race service including race wax for your top performance.',
      feature1: 'Pour base and fill all large and small gouges',
      feature2: 'Base pre-grinding',
      feature3: 'Base fine-grinding',
      feature4: 'Edge sharpening – side',
      feature5: 'Edge sharpening – base bevel',
      feature6: 'Deep wax treatment',
      feature7: 'Polishing',
      feature8: 'Race wax finish',
      mobileFeature1: 'Base repair, fill & grind',
      mobileFeature2: 'Edge sharpening',
      mobileFeature3: 'Deep wax treatment & polishing',
      mobileFeature4: 'Race wax finish',
    },
  },

  pricing: {
    sectionTitle: 'CHOOSE YOUR SERVICE',
    sectionSubtitle: 'Professional quality. All prices per pair of skis.',
    badgeKids: 'KIDS',
    badgePopular: 'POPULAR',
    badgePremium: 'PREMIUM',
    discount: 'Introductory discount',
    perPair: '/pair',
    bookButton: 'BOOK',
    mobileBookButton: 'BOOK',
    detailsShow: 'Details',
    detailsHide: 'Less',
    scrollHint: '← Swipe for more options →',
    juniorLengthNote: 'Only for skis up to 1.5 m in length',
    pickupIncluded: 'Pickup at your accommodation and return the next morning',
  },

  trustBar: {
    label: 'Quality Promise',
    headline: 'Not satisfied? We redo the service free of charge.',
    subtext: 'Our quality guarantee – no ifs or buts.',
    watermark: 'GUARANTEE',
    item1Title: 'Local experts with years of experience',
    item1Desc: 'Our specialists at our partner workshop in Klosters know skis and snow – service at the highest level.',
    item2Title: 'Photo documentation at every handover',
    item2Desc: 'We document the condition of your skis at pickup and return – transparent and traceable.',
    item3Title: 'Full liability for damages',
    item3Desc: 'Should any damage occur to your skis during pickup, service or return, we take full responsibility.',
    workshopLabel: 'Partner workshop in Klosters',
  },

  booking: {
    title: 'BOOK YOUR SERVICE',
    stepService: 'Service',
    stepAddress: 'Address',
    stepPayment: 'Payment',
    stepAddressTitle: 'Address Details',
    positionLabel: 'Position {{n}}',
    pairsLabel: 'Number of pairs',
    addServiceButton: 'Add another service',
    alreadySelected: '(already selected)',
    plzSelectLabel: 'Select postal code & city',
    toAddressButton: 'to address details',
    toPaymentButton: 'to payment',
    errorServiceRequired: 'Please add at least one service',
    errorDateRequired: 'Please select pick-up date',
    errorReturnDateRequired: 'Please select return date',
    errorPickupRequired: 'Please select pick-up location',
    pairCount_one: '{{count}} pair',
    pairCount_other: '{{count}} pairs',
    serviceCount_one: '{{count}} service',
    serviceCount_other: '{{count}} services',
    labelName: 'Name',
    placeholderName: 'Your full name',
    labelAddress: 'Accommodation / Address',
    placeholderAddress: 'e.g. Landstrasse 12, 7250 Klosters',
    labelCareOf: 'c/o – Name on doorbell / Hotel',
    placeholderCareOf: 'e.g. Müller Family, Hotel Alpina, Chalet Alpenblick',
    careOfOptional: 'optional',
    careOfHint: 'If your name is not on the doorbell – enter the name that is there (owner, hotel, etc.).',
    addressValidating: 'Address is being verified...',
    addressConfirmed: 'Address found and confirmed.',
    addressHint: 'Allowed postal codes: 7247 (Saas), 7249 (Serneus), 7250 (Klosters), 7252 (Klosters-Dorf)',
    errorInvalidPLZ: 'Please enter a valid postal code: 7247, 7249, 7250 or 7252.',
    errorAddressNotFound: 'This address could not be found. Please check your entry (e.g. street, house number and postal code).',
    labelPhone: 'Phone',
    placeholderPhone: '+41 XX XXX XX XX',
    labelEmail: 'Email',
    placeholderEmail: 'your@email.ch',
    labelService: 'Service Selection',
    serviceJunior: 'JUNIOR SERVICE',
    serviceKleiner: 'STANDARD SERVICE',
    serviceGrosser: 'PRO SERVICE',
    serviceRenn: 'RACE SERVICE',
    optionJunior: 'JUNIOR SERVICE - 29 CHF (Edge sharpening, base waxing, structure grinding – up to 1.5 m)',
    optionKleiner: 'STANDARD SERVICE - 49 CHF (Edge sharpening, base waxing, structure grinding)',
    optionGrosser: 'PRO SERVICE - 69 CHF (Base repair, structure grinding, edge sharpening, deep wax treatment)',
    optionRenn: 'RACE SERVICE - 79 CHF (Deep wax treatment, race wax finish, edge sharpening, base repairs)',
    labelPickupDate: 'Pick-up date',
    pickupDateHint: '(Order by {{orderDeadline}} at the latest)',
    labelReturnDate: 'Return on',
    returnDateHint: '(back by {{returnTime}} at the latest)',
    labelPairs: 'Number of ski pairs',
    pairLabel_one: 'pair',
    pairLabel_other: 'pairs',
    labelPickupLocation: 'Where can we pick up your skis?',
    pickupDoor: 'At the front door',
    pickupRing: 'Please ring the bell',
    pickupReception: 'Please ask at reception',
    pickupCall: 'Please call when picking up',
    submitButton: 'TO BOOKING OVERVIEW',
    submitting: 'SENDING...',
    validatingAddress: 'VALIDATING ADDRESS...',
    errorSubmit: 'There was a problem sending. Please try again.',
    footerNote: 'Order service by {{orderDeadline}} • Return by {{returnTime}}',
    marketingConsentLabel: 'I would like to be informed by email about promotions, discounts and news from Ski-Service Courier. Consent can be withdrawn at any time.',
    marketingConsentShort: 'Newsletter',
  },

  payment: {
    title: 'PAYMENT',
    summaryTitle: 'Booking Overview',
    pickupLabel: 'Pick-up',
    pickupTime: 'by {{deliveryTime}}',
    returnLabel: 'Return',
    returnTime: 'by {{returnTime}}',
    locationLabel: 'Pick-up location',
    totalLabel: 'TOTAL',
    methodTitle: 'Select payment method',
    methodCredit: 'Credit card',
    methodPaypal: 'PayPal',
    methodApple: 'Apple Pay',
    methodTwint: 'TWINT',
    payButton: 'PAY {{amount}} CHF',
    processing: 'PROCESSING...',
    secureNote: 'Secure payment – Your data is encrypted',
    successTitle: '🎿 Thank you for your booking!',
    successMessage1: 'Your booking is confirmed. A confirmation email has been sent to your address.',
    successMessage2: 'We will pick up your skis on the agreed evening and bring them back by {{returnTime}}, perfectly prepared.',
    successMessage3: 'Please make sure your skis are ready at the selected location by {{skiReadyTime}}.',
    successButton: 'OK',
    pairLabel_one: 'pair',
    pairLabel_other: 'pairs',
    initializing: 'Preparing payment...',
    errorTitle: 'Loading error',
    errorInit: 'Payment could not be initialized. Please try again.',
    errorGeneric: 'An error occurred. Please try again.',
    retry: 'Try again',
  },

  footer: {
    tagline: 'PERFECT SKIS – COMPLETELY CONVENIENT',
    serviceTitle: 'SKI SERVICE',
    serviceJunior: 'Junior Service',
    serviceKleiner: 'Standard Service',
    serviceGrosser: 'Pro Service',
    serviceRenn: 'Race Service',
    legalTitle: 'LEGAL',
    legalTerms: 'Terms & Conditions',
    legalPrivacy: 'Privacy Policy',
    legalImprint: 'Imprint',
    contactTitle: 'CONTACT',
    newsletterTitle: 'GET UPDATES',
    newsletterDescription: 'Receive exclusive offers and news directly in your inbox.',
    newsletterPlaceholder: 'Your email',
    feedbackTitle: 'YOUR FEEDBACK',
    feedbackDescription: 'How was your experience with Ski Service Courier? We appreciate your feedback.',
    feedbackPlaceholder: 'Your comment (optional)...',
    feedbackSubmit: 'SUBMIT',
    feedbackSubmitting: 'SUBMITTING...',
    feedbackSuccess: 'Thank you for your feedback! 🎿',
    feedbackRating1: 'Poor',
    feedbackRating2: 'Below average',
    feedbackRating3: 'OK',
    feedbackRating4: 'Good',
    feedbackRating5: 'Excellent',
    copyright: '© {{year}} Ski Service Courier. All rights reserved.',
    poweredBy: 'Powered by Readdy',
    watermark: 'SKI SERVICE COURIER',
  },

  feedback: {
    headline: 'HOW WAS YOUR EXPERIENCE?',
  },

  common: {
    close: 'Close',
    previousSection: 'Previous section',
    nextSection: 'Next section',
    toSection: 'To section',
  },

  imprint: {
    companyName: 'Service Kurier GmbH (in Gründung)',
    street: 'Talstrasse 57',
    city: '7250 Klosters',
    statusLabel: 'Company Status',
    statusValue: 'Company in formation',
    contactLabel: 'Contact',
  },

  terms: {
    title: 'General Terms and Conditions (GTC)',
    lastUpdated: 'As of: January 2025',
    s1Title: '1. Scope',
    s1Text: 'These General Terms and Conditions apply to all services provided by Service Kurier GmbH (in formation), Talstrasse 57, 7250 Klosters (hereinafter "Provider"), to customers (hereinafter "Customer").',
    s2Title: '2. Service Description',
    s2Text: 'The provider offers a ski service courier service. Skis are picked up from the customer in the evening, professionally serviced and returned the next morning by {{returnTime}} at the latest. Orders must be placed by {{orderDeadline}} on the desired pick-up day.',
    s3Title: '3. Contract Conclusion',
    s3Text: 'The contract is concluded with the booking confirmation by email. The customer is obliged to provide correct information. Incorrect information may lead to cancellation of the booking.',
    s4Title: '4. Prices and Payment',
    s4Text: 'All prices are in Swiss Francs (CHF) including VAT. Payment is made online when booking. Accepted payment methods: credit card, TWINT, Apple Pay, PayPal.',
    s5Title: '5. Cancellation',
    s5Text: 'Cancellations are possible free of charge until 12:00 noon on the pick-up day. For later cancellations or no-shows, the full amount will be charged. Cancellations must be sent by email to klosters@ski-service-kurier.ch.',
    s6Title: '6. Liability',
    s6Text: 'The provider is liable for damage to the skis that demonstrably occurred during transport or service. Liability is limited to the current value of the damaged item. No liability is assumed for damage caused by force majeure.',
    s7Title: '7. Applicable Law',
    s7Text: 'Swiss law applies. Place of jurisdiction is Klosters, Switzerland.',
  },

  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'As of: January 2025',
    s1Title: '1. Responsible Party',
    s1Text: 'Responsible for data processing is Service Kurier GmbH (in formation), Talstrasse 57, 7250 Klosters, email: klosters@ski-service-kurier.ch.',
    s2Title: '2. Data Collected',
    s2Text: 'When booking, we collect the following data: name, address/accommodation, phone number, email address, and payment information. This data is used exclusively for processing the order.',
    s3Title: '3. Purpose of Processing',
    s3Text: 'Your data is used for: order processing and communication, sending booking confirmations, invoicing, and improving our services.',
    s4Title: '4. Marketing Emails',
    s4Text: 'With your explicit consent (opt-in in the booking form), we use your email address to inform you about promotions, discounts, and news. This consent is voluntary and can be withdrawn at any time without giving reasons – by email to klosters@ski-service-kurier.ch or via the unsubscribe link in any marketing email.',
    s5Title: '5. Disclosure to Third Parties',
    s5Text: 'Your data will not be sold to third parties. Disclosure only occurs where necessary for contract fulfillment (e.g., payment service providers) or required by law.',
    s6Title: '6. Data Security',
    s6Text: 'We use technical and organizational measures to protect your data from unauthorized access, loss, or misuse. Payment processing is encrypted via certified providers.',
    s7Title: '7. Retention Period',
    s7Text: 'Your data is stored only as long as necessary for order processing or as required by legal retention obligations (generally 10 years for accounting records).',
    s8Title: '8. Your Rights',
    s8Text: 'You have the right to access, correct, delete, and restrict the processing of your data. Please send requests to: klosters@ski-service-kurier.ch.',
    s9Title: '9. Cookies',
    s9Text: 'Our website uses technically necessary cookies to ensure the operation of the site. No tracking or advertising cookies are used.',
  },
};
